import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { ModulesInfo } from "../../constants/modules"

import { documentQueryKeys } from "./queryKeys"

export function useElementQuery(elementType, elementId, config = {}) {
    const baseUrl = ModulesInfo?.[elementType]?.queryUrl
    const url = `${baseUrl}/${elementId}/`
    const queryKey = documentQueryKeys.element(elementId)

    const { enabled = true } = config
    const { selectedNetwork } = useNetworksStateContext()
    queryKey.push({ network: selectedNetwork?.slug })

    return useAuthenticatedQuery(
        url,
        queryKey,
        { project: selectedNetwork?.slug },
        {
            ...config,
            enabled: !!selectedNetwork?.slug && enabled && !!elementType && !!elementId,
        },
    )
}